module.exports = __webpack_public_path__ + "media/images/Grey Cabinets Crown Molding sq-ebaee13c.jpg";